import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import apiPublicSettingsRoutes from 'modules/api_public/routes/settings'
import atsSettingsRoutes from 'modules/ats/routes/settings'
import timeTrackingSettingsRoutes from 'modules/attendance/routes/settings'
import auditLogSettingsRoutes from 'modules/audit_log/routes/settings'
import automationsSettingsRoutes from 'modules/automations/routes/settings'
import benefitsSettingsRoutes from 'modules/benefits/lib/settings'
import billingSettingsRoutes from 'modules/billing/routes/settings'
import companyPageSettingsRoutes from 'modules/company_page/routes/settings'
import compensationsSettingsRoutes from 'modules/compensations/routes/settings'
import complaintsSettingsRoutes from 'modules/complaints/routes/settings'
import contractsSettingsRoutes from 'modules/contracts_settings/routes'
import customResourcesSettingsRoutes from 'modules/custom_resources/routes/settings'
import documentsSettingsRoutes from 'modules/documents/routes/settings'
import employeeOnboardingSettingsRoutes from 'modules/employees/routes/settings'
import engagementSettingsRoutes from 'modules/engagement/routes/settings'
import expensesSettingsRoutes from 'modules/expenses/routes/settings'
import externalsSettingsRoutes from 'modules/external_users/routes/settings'
import financeSettingsRoutes from 'modules/finance/routes/settings'
import legalEntitiesSettingsRoutes from 'modules/legal_entities/routes/settings'
import locationsSettingsRoutes from 'modules/locations/routes/settings'
import payrollBundleSettingsRoutes from 'modules/payroll_bundle/routes/settings'
import performanceProcessSettingsRoutes from 'modules/performance_process/routes/settings'
import permissionsSettingsRoutes from 'modules/permissions/routes/settings'
import purchaseRquestsSettingsRoutes from 'modules/procurement/routes/settings'
import referralProgramSettingsRoutes from 'modules/referral_program/routes/settings'
import { securitySettingsRoutes } from 'modules/security_settings/routes'
import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'
import detailsSettingsRoutes from 'modules/settings/routes/details'
import softwareSettingsRoutes from 'modules/software_management/routes/settings'
import surveysSettingsRoutes from 'modules/surveys/routes/settings'
import timeCategoriesSettingsRoutes from 'modules/time_categories_settings/routes'
import timeoffSettingsRoutes from 'modules/timeoff/routes/settings'
import trainingSettingRoutes from 'modules/trainings/routes/settings'
import universalImporterSettingsRoutes from 'modules/universal_importer/routes/settings'
import workSchedulesSettingsRoutes from 'modules/work_schedules/routes/settings'

const RootPage = React.lazy(() => import('modules/settings/pages/RootPage'))
const CustomizationsPage = React.lazy(
  () => import('modules/settings/pages/CustomizationsPage/index')
)
const NavigateSettingsPage = React.lazy(() => import('modules/settings/pages/NavigateSettingsPage'))

export const settingsRoutes = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      path: navigation.settings.path,
      element: <RootPage />,
      handle: {
        module: 'settings',
        moduleName: () => i18n.t('company_settings.title'),
        meta: () => ({ title: i18n.t('company_settings.title') }),
      },
      children: [
        {
          index: true,
          element: <NavigateSettingsPage />,
        },
        {
          path: navigation.settings.customizations.path,
          element: <CustomizationsPage />,
          handle: {
            meta: () => getSettingPageMeta(navigation, 'customizations') ?? {},
          },
          children: [...customResourcesSettingsRoutes(navigation)],
        },
        ...apiPublicSettingsRoutes(navigation),
        ...atsSettingsRoutes(navigation),
        ...auditLogSettingsRoutes(navigation),
        ...automationsSettingsRoutes(navigation),
        ...benefitsSettingsRoutes(navigation),
        ...billingSettingsRoutes(navigation),
        ...companyPageSettingsRoutes(navigation),
        ...compensationsSettingsRoutes(navigation),
        ...complaintsSettingsRoutes(navigation),
        ...contractsSettingsRoutes(navigation),
        ...detailsSettingsRoutes(navigation),
        ...documentsSettingsRoutes(navigation),
        ...employeeOnboardingSettingsRoutes(navigation),
        ...engagementSettingsRoutes(navigation),
        ...expensesSettingsRoutes(navigation),
        ...externalsSettingsRoutes(navigation),
        ...financeSettingsRoutes(navigation),
        ...legalEntitiesSettingsRoutes(navigation),
        ...locationsSettingsRoutes(navigation),
        ...payrollBundleSettingsRoutes(navigation),
        ...performanceProcessSettingsRoutes(navigation),
        ...permissionsSettingsRoutes(navigation),
        ...purchaseRquestsSettingsRoutes(navigation),
        ...referralProgramSettingsRoutes(navigation),
        ...securitySettingsRoutes(navigation),
        ...softwareSettingsRoutes(navigation),
        ...surveysSettingsRoutes(navigation),
        ...timeCategoriesSettingsRoutes(navigation),
        ...timeTrackingSettingsRoutes(navigation),
        ...timeoffSettingsRoutes(navigation),
        ...trainingSettingRoutes(navigation),
        ...workSchedulesSettingsRoutes(navigation),
        ...universalImporterSettingsRoutes(navigation),
      ],
    }),
  ]
})
